/**
 * Canonical display-name rule, shared by every identity surface on both
 * platforms (history drawer, settings summary).
 *
 * RAI-1099: the mobile settings header showed "You" while the drawer showed
 * the user's real name for the same account. Both had the same inputs
 * available; only the drawer consulted the Logto profile. The DB
 * first/last-name fields are frequently empty — nothing in the backend
 * populates them at signup — so the Logto `name` claim is the primary
 * real-world source and every surface must consult it.
 *
 * "You" is the terminal fallback, not the common case.
 */
export function resolveUserDisplayName(args: {
  /** `first_name`/`last_name` from the DB user, already joined; often "". */
  dbFullName: string | null | undefined;
  email: string | null | undefined;
  /** The `name` claim from the identity provider profile. */
  identityName: string | null | undefined;
}): string {
  return (
    normalize(args.dbFullName) ??
    normalize(args.identityName) ??
    normalize(args.email) ??
    "You"
  );
}

function normalize(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed !== undefined && trimmed.length > 0 ? trimmed : null;
}
